import React, { useState, useEffect } from "react";
import logo from "../assets/logo.jpg";
import "./Header.css";
import { useNavigate } from 'react-router-dom';
const Header = ({ loginHandler, isLoggedin }) => {
  let navigate = useNavigate();
  const [navBg, setNavBg] = useState(false);
  const changeNavBg = () => {
    window.scrollY >= 200 ? setNavBg(true) : setNavBg(false);
   }
   useEffect(() => {
    window.addEventListener('scroll', changeNavBg);
    return () => {
      window.removeEventListener('scroll', changeNavBg);
    }
  }, [])
  return (
    <header className="top-nav-header">
      {/* Pasek nawigacyjny */}
     
      <div className={navBg ? "top-nav-scroll" : "top-nav"}>
        <nav className="nav">
          <ul className="nav-list-left">
          {navBg ? (
          <img onClick={() => { navigate(""); window.scrollTo({ top: 0, behavior: 'smooth' }); }} src={logo} alt="Logo" className={navBg ? "logo-imagee-scroll" : "logo-imagee"} />
        ): ""}
          {navBg ? (<li onClick={() => {  navigate(""); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="nav-item">EKSELOWE.PL</li> ): ""}
            {isLoggedin ? <li className="nav-item-left" onClick={loginHandler}>Wyloguj</li> : ""}
            {isLoggedin ? <li onClick={() => navigate("/dashboard")} className="nav-item">Dashboard</li> : ""}
          </ul>
          <ul className="nav-list">
            <li onClick={() => {
              navigate(""); window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
              className="nav-item">Start</li>
            <li onClick={() => { navigate("/aktualnosci"); }}
              className="nav-item">Aktualności</li>
            <li onClick={() => { navigate("/"); }}
              className="nav-item"><a href='#service-panel-id'>Usługi</a></li>
            <li onClick={() => { navigate("/"); }}
              className="nav-item"><a href='#footer-left'>Kontakt</a></li>

          </ul>
        </nav>
      </div>


    </header>
  );
};

export default Header;
